import { render, staticRenderFns } from "./EditarPostagens.vue?vue&type=template&id=822606f2&scoped=true"
import script from "./EditarPostagens.vue?vue&type=script&lang=js"
export * from "./EditarPostagens.vue?vue&type=script&lang=js"
import style0 from "./EditarPostagens.vue?vue&type=style&index=0&id=822606f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "822606f2",
  null
  
)

export default component.exports